import React from "react";
import moment from "moment";

/**
 * format PR copyright text
 * @return {}
 */
const PRCopyright = () => {
    return <div className="copyright">&copy; {moment().year()} PublicRelay</div>
}

export default PRCopyright;